import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { OrderWithContext, RestaurantAddress, Restaurant, OrderDeliveryInfo } from '@/models';
import { RestaurantEmbeds } from '@/services/restaurant/restaurant.service';
import { OrderAndHistorySustainabilityMetrics } from '@/models/sustainability';
import { isSustainabilityEnabled } from '@/helpers';

@Component({
  name: 'CmgOrderConfirmation',
})
export default class CmgOrderConfirmation extends Vue {
  restaurant: Restaurant | null = null;

  @Prop({ required: true, type: Object })
  order!: OrderWithContext;

  @Prop({ type: Object })
  deliveryInfo?: OrderDeliveryInfo;

  get restaurantAddress(): RestaurantAddress | null {
    return this.restaurant && this.restaurant.address;
  }

  get isPickup(): boolean {
    return !this.order.order.delivery;
  }

  get isReady(): boolean {
    return !!this.order && !!this.restaurant;
  }

  get isGuest(): boolean {
    return this.$services.customer.isLoggedIn() !== true;
  }

  get hasFailed2SV(): boolean {
    return this.$appStore.state.ui.orderConfirmation.hasFailed2SV;
  }

  get isEnrolledInLoyalty(): boolean {
    return this.$services.loyalty.isEnrolledInLoyalty(this.$appStore.state.customer.profile);
  }

  get isEligibleForLoyalty(): boolean {
    return this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile);
  }

  get paidInStore(): boolean {
    return !this.order.order.isAboveStorePayment;
  }

  get isSustainabilityEnabled(): boolean {
    return isSustainabilityEnabled(this.restaurant?.address?.countryCode ?? '')
  }

  get sustainabilityMetrics(): OrderAndHistorySustainabilityMetrics {
    return this.$appStore.state.customer.sustainabilityMetrics;
  }

  get joinedLoyaltyOnOrderConfirmationPage(): boolean {
    return this.$appStore.state.customer.loyalty.joinedLoyaltyOnOrderConfirmationPage;
  }

  async mounted() {
    this.restaurant = await this.$services.restaurant.getRestaurantByNumber(this.order.order.restaurantId, [
      RestaurantEmbeds.Addresses,
      RestaurantEmbeds.Directions,
      RestaurantEmbeds.Chipotlane,
      RestaurantEmbeds.Experience,
    ]);

    this.signalAdobeTargetChurrosConversion();
  }

  private signalAdobeTargetChurrosConversion() {
    const wasChurrosToastDisplayed = this.$appStore.state.ui.churrosToastAlreadyDisplayed;
    if (wasChurrosToastDisplayed) {
      this.$services.utils.targetEvent('orderedChurrosSuccess');
      this.$services.ui.setChurrosToastAlreadyDisplayed(false);
    }
  }
}
